import { cn } from "@/lib/utils";

type SliderFieldProps = {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  valueLabel: string;
  accentColorClass?: string;
  onChange: (value: number) => void;
};

export default function SliderField({
  label,
  value,
  min,
  max,
  step = 1,
  valueLabel,
  accentColorClass = "accent-emerald-500",
  onChange,
}: SliderFieldProps) {
  return (
    <div className="mb-2 flex-shrink-0 rounded-xl bg-muted p-2">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-xs text-muted-foreground">{label}</span>
        <span className="text-xs font-medium text-foreground">{valueLabel}</span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        aria-label={label}
        aria-valuetext={valueLabel}
        onChange={(e) => onChange(Number(e.target.value))}
        className={cn(
          "h-2 w-full cursor-pointer appearance-none rounded-lg bg-muted-foreground/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          accentColorClass
        )}
      />
    </div>
  );
}
